import { Outlet, useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';

import { Button } from '@itds/elements/index.js';
import { CarrierContext } from '@carrier/contexts/CarrierContext';
import { Colors } from '@itds/Theme';
import Cookies from 'js-cookie';
import { format } from 'date-fns';
import { useNotification } from '@carrier/utils/custom_hooks/useNotification';
import Config from '@/config';

const Authenticated = () => {
  const navigate = useNavigate();
  const { notification, setNotification } = useNotification({ type: null, message: '' });
  const context = {
    notification,
    setNotification
  };
  const styles = {
    header: {
      background: Colors.GRAY.hex,
      padding: '0 20px',
      marginBottom: '40px',
      display: 'flex',
      alignItems: 'center'
    },
    header_link: {
      color: '#fff',
      textDecoration: 'none',
      padding: '33px 15px',
      fontWeight: 500,
      position: 'relative',
      cursor: 'pointer'
    },
    header_link_active_after: {
      content: '',
      display: 'block',
      width: '0',
      height: '0',
      position: 'absolute',
      bottom: '0',
      borderBottom: '10px solid #fff',
      borderLeft: '10px solid transparent',
      borderRight: '10px solid transparent',
      left: '50%',
      transform: 'translateX(-50%)'
    },
    logo: {
      backgroundImage: "url('https://ixn.s3.us-west-2.amazonaws.com/prod/img/logo_white.png')",
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      width: '70px',
      height: '34px',
      marginRight: '40px'
    },
    footer: {
      textAlign: 'center',
      padding: 50
    }
  };

  useEffect(() => {
    // TODO: Secure this more by validating the jwt from the cookie
    if (!Cookies.get('control-room-c')) {
      navigate('/');
    }
  }, []);

  const logout = () => {
    Cookies.remove('control-room-c');
    navigate('/');
  };

  const iconClicked = () => {
    navigate('/');
  };

  return (
    <>
      <div style={styles.header}>
        <div onClick={iconClicked} style={styles.logo} />

        <div style={{ display: 'flex', alignItems: 'center' }}>
          {[
            { label: 'Carriers', to: 'carriers' },
            { label: 'Vendors', to: 'vendors' },
            { label: 'AMBest Records', to: 'ambest_records' },
            { label: 'Resources', to: 'resources' },
            { label: 'Admins', to: 'admins' },
            { label: 'ApiTokens', to: 'api_tokens' }
          ].map((link, i) => {
            return (
              <div key={i} onClick={navigate.bind(null, `/${link.to}`)} style={styles.header_link}>
                {link.label}
                {window.location.hash.split('/')[1] === link.to ? (
                  <div style={styles.header_link_active_after} />
                ) : null}
              </div>
            );
          })}
          {/* External link to Health Analyzer admin, opens in new tab */}
          <a
            href={Config.HA_ADMIN_URL}
            rel='noopener noreferrer'
            style={styles.header_link}
            target='_blank'
          >
            Health Analyzer
          </a>
        </div>
        <Button
          color='RED'
          icon='logout'
          onClick={logout}
          small={true}
          style={{ marginLeft: 'auto' }}
        >
          Log Out
        </Button>
      </div>
      <CarrierContext.Provider value={context}>
        <Outlet />
      </CarrierContext.Provider>

      <footer style={styles.footer}>&copy; {format(new Date(), 'yyyy')} IXN</footer>
    </>
  );
};

export default Authenticated;
